module.exports = __webpack_public_path__ + "static/media/item_12_2_comp.57aab8c4.png";